<template>
  <Form @submit="onSubmit">
    <div class="my-3">
      <div
        class="bg-gray-450 p-4 md:w-full pl-6 rounded-full w-8/12 xs:w-full sm:w-full lg:w-10/12 flex items-center"
        :class="{ active: isActive }"
      >
        <Field
          name="paymentMethod"
          type="radio"
          value="paypal"
          class="mr-3"
          :model-value="modelValue"
          @update:model-value="$emit('update:modelValue', $event)"
        />
        <label for="paymentMethod" class="font-medium">Pay Pal</label>
      </div>
      <div
        v-if="isActive"
        class="bg-gray-450 p-4 md:w-full pl-6 pt-6 rounded-br-3xl rounded-bl-3xl transition-all text-center"
      >
        <div id="smart-button-container" class="xs:w-full md:w-full sm:w-full w-8/12">
          <div style="text-align: center">
            <div id="paypal-button-container"></div>
          </div>
        </div>
      </div>
    </div>
  </Form>
</template>

<script setup>
import { computed } from 'vue';
import { Form, Field } from 'vee-validate';

const props = defineProps({
  modelValue: String,
  onSubmit: Function
});

defineEmits(['update:modelValue']);

const isActive = computed(() => props.modelValue === 'paypal');
</script>

<style scoped>
.active {
  @apply rounded-br-none rounded-bl-none bg-red text-white rounded-tr-2xl rounded-tl-2xl w-full;
}
</style>
